import { BaseHttpClient, baseOk, ApiOk } from "./base";
import {
  findHandlesResponseSchema,
  findListingsResponseSchema,
  findProfileResponseSchema,
  type FindHandlesResponse,
  type FindListingsQuery,
  type FindListingsResponse,
  type FindProfileResponse,
} from "@openings/api-contract";

const listingsResponse = baseOk(findListingsResponseSchema);
const profileResponse = baseOk(findProfileResponseSchema);
const handlesResponse = baseOk(findHandlesResponseSchema);

export type FindListingsResult = ApiOk<FindListingsResponse>;
export type FindProfileResult = ApiOk<FindProfileResponse>;
export type FindHandlesResult = ApiOk<FindHandlesResponse>;

/** Public reads behind find.openings.link (plans/find-listing-spec.md). */
export class FindClient extends BaseHttpClient {
  /** Listed men's haircut stylists, nearest first with a viewer location. */
  listings(query: FindListingsQuery = {}): Promise<FindListingsResult> {
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (value != null) qs.set(key, String(value));
    }
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return this.getStrict(`/v1/find/listings${suffix}`, listingsResponse);
  }

  /** Listed handles for the sitemap, without the openings search. */
  handles(): Promise<FindHandlesResult> {
    return this.getStrict(`/v1/find/handles`, handlesResponse);
  }

  /** A stylist's profile; throws with `status: 404` when it is not listed. */
  profile(handle: string): Promise<FindProfileResult> {
    return this.getStrict(`/v1/find/profiles/${encodeURIComponent(handle)}`, profileResponse);
  }
}
